// extracted by mini-css-extract-plugin
export default {"checkboxMSS":"mss_checkboxMSS__zGHKS"};